var NativeAsset = require('./NativeAsset');

module.exports = new NativeAsset({
  id: 'xdai',
  name: 'xDai',
  network: '100',
  usdPrice: 1
});